import { render } from "./HolidayRequestView.vue?vue&type=template&id=6efa20d6&scoped=true"
import script from "./HolidayRequestView.vue?vue&type=script&lang=js"
export * from "./HolidayRequestView.vue?vue&type=script&lang=js"

import "./HolidayRequestView.vue?vue&type=style&index=0&id=6efa20d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efa20d6"]])

export default __exports__